import React from 'react'

const NotAvailable = () => {
  return (
    <div className="not-available-container" style={{ 
      textAlign: 'center', 
      padding: '50px 20px' 
    }}>
      <h1>Service Not Available</h1>
      <p>We apologize, but our services are currently only available in India.</p>
      <p>We're working on expanding to other regions. Thank you for your interest!</p>
    </div>
  )
}

export default NotAvailable
